import {
	Sun,
	Moon,
	Satellite,
	Globe,
	Users,
	Cpu,
	Factory,
	Timer,
	UtilityPole,
	HousePlugIcon,
	TrafficConeIcon,
	BatteryLowIcon
} from 'lucide-react';
import { Layer, LayerUIConfig, MapStyle, MapStyleOption, Stops } from './types';

export const API_SOURCE_PATH = '/api/v1/geomap';

export const GEOMAP_SOURCE_ID = 'root';

export const YES_MAPBOX_TRANSMISSION_ID = 'yes-mapbox-transmission';

export const YES_MAPBOX_SUBSTATIONS_ID = 'yes-mapbox-substations';

export const GOOGLE_MAPS_URL = 'https://www.google.com/maps';

export const LAYERS_UI_CONFIG: Record<Layer, LayerUIConfig> = {
	[Layer.Landowners]: {
		id: Layer.Landowners,
		name: 'Landowners',
		visible: true,
		Icon: Users,
		description: 'Property owner locations'
	},
	[Layer.Devices]: {
		id: Layer.Devices,
		name: 'Devices',
		visible: true,
		Icon: Cpu,
		description: 'Measurement stations'
	},
	[Layer.Plants]: {
		id: Layer.Plants,
		name: 'Plants',
		visible: true,
		Icon: Factory,
		description: 'Power generation facilities'
	},
	[Layer.Ttms]: {
		id: Layer.Ttms,
		name: 'TTMS',
		visible: true,
		Icon: Timer,
		description: 'Time Tag Measurement Station'
	},
	[Layer.EiaTransmission]: {
		id: Layer.EiaTransmission,
		name: 'EIA Transmission',
		visible: true,
		Icon: UtilityPole,
		description: 'High voltage power transmission lines',
		stops: [
			{ label: '0-99 kV', color: '#cccc33', min: -Infinity, max: 90 },
			{ label: '100-229 kV', color: '#3366cc', min: 100, max: 229 },
			{ label: '230-344 kV', color: '#006633', min: 230, max: 344 },
			{ label: '345-499 kV', color: '#ff6633', min: 345, max: 499 },
			{ label: '500+ kV', color: '#000000', min: 500, max: Infinity }
		]
	},
	[Layer.EiaSubstations]: {
		id: Layer.EiaSubstations,
		name: 'EIA Substations',
		visible: true,
		Icon: HousePlugIcon,
		description: 'Electrical substations'
	},
	[Layer.PlannedPlants]: {
		id: Layer.PlannedPlants,
		name: 'Planned Plants',
		visible: true,
		Icon: TrafficConeIcon,
		description: 'Planned power generation facilities'
	},
	[Layer.Loads]: {
		id: Layer.Loads,
		name: 'Loads',
		visible: true,
		Icon: BatteryLowIcon,
		description: 'Current and planned loads'
	}
};

export const MAP_STYLES: MapStyleOption[] = [
	{
		id: 'light',
		name: 'Light',
		url: 'mapbox://styles/mapbox/light-v11',
		icon: <Sun className="h-4 w-4" />
	},
	{
		id: 'dark',
		name: 'Dark',
		url: 'mapbox://styles/mapbox/dark-v11',
		icon: <Moon className="h-4 w-4" />
	},
	{
		id: 'satellite',
		name: 'Satellite',
		url: 'mapbox://styles/mapbox/satellite-streets-v12',
		icon: <Satellite className="h-4 w-4" />
	},
	{
		id: 'standard',
		name: 'Standard',
		url: 'mapbox://styles/mapbox/standard',
		icon: <Globe className="h-4 w-4" />
	}
];

export function getStopsArray(stops: Stops[] | undefined): [number, string][] {
	if (!stops || stops.length === 0) {
		return [];
	}

	return stops.map((stop: Stops) => [isFinite(stop.min) ? stop.min : 0, stop.color]);
}

export function getMapStyleUrl(styleId: MapStyle): string {
	return MAP_STYLES.find(style => style.id === styleId)?.url || 'mapbox://styles/mapbox/light-v11';
}
